import React from 'react';

import { FlexContainer } from 'components/common/FlexContainer';
import { TransparentContainer } from 'components/common/TransparentContainer';
import { PageDescription } from 'components/page/PageDescription';
import { PageTitle } from 'components/page/PageTitle';
import { ForYouIntroToSecond } from 'components/common/connectionLines/ForYouIntroToSecond';
import { Wrapper } from './atoms/Wrapper';
import { SectionIntroWrapper } from './atoms/SectionIntroWrapper';
import { ImageWrapper } from './atoms/ImageWrapper';
import { VideoContainer } from './atoms/VideoContainer';

interface Props {
    title: string;
    description: string;
}
export const ForYouIntro: React.FC<Props> = ({ title, description }) => {
    return (
        <FlexContainer>
            <TransparentContainer>
                <Wrapper>
                    <SectionIntroWrapper>
                        <div>
                            <PageTitle>{title}</PageTitle>
                            <PageDescription>{description}</PageDescription>
                        </div>
                    </SectionIntroWrapper>
                    {/* TODO: This should come from the API */}
                    <ImageWrapper>
                        <VideoContainer>
                            <iframe
                                src="https://www.youtube.com/embed/z5KIY6N_3ko"
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </VideoContainer>
                    </ImageWrapper>
                    <ForYouIntroToSecond />
                </Wrapper>
            </TransparentContainer>
        </FlexContainer>
    );
};
